import { render, staticRenderFns } from "./DataComponents.vue?vue&type=template&id=10d064e2&scoped=true"
import script from "./DataComponents.vue?vue&type=script&lang=js"
export * from "./DataComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d064e2",
  null
  
)

export default component.exports